import React, { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';

// eslint-disable-next-line no-restricted-imports
import { loadHeader } from 'app/gamma/src/modules/loaders/load-header';
import { memberId } from '@trello/session-cookie';
import { ComponentWrapper } from 'app/src/components/ComponentWrapper';
import {
  LazyLoggedOutHeader,
  LoggedOutNavExperimentVariations,
  useLoggedOutHeaderExperiment,
} from 'app/src/components/LoggedOutHeader';
import { addSubscription } from 'app/scripts/init/subscriber';
import { AnonymousHeader } from './AnonymousHeader';
import { AuthenticatedHeader } from './AuthenticatedHeader';

const AnonymousHeaderWrapper: React.FunctionComponent = () => {
  const loggedOutHeaderVariation = useLoggedOutHeaderExperiment({
    sendExposureEvent: true,
  });

  return loggedOutHeaderVariation ===
    LoggedOutNavExperimentVariations.EXPERIMENT ? (
    <LazyLoggedOutHeader />
  ) : (
    <AnonymousHeader />
  );
};

export const HeaderContainer = () => {
  const dispatch = useDispatch();

  const loadHeaderData = useCallback((id) => dispatch(loadHeader(id)), [
    dispatch,
  ]);

  useEffect(() => {
    if (memberId) {
      return addSubscription({
        modelType: 'Member',
        idModel: memberId,
        tags: ['messages', 'updates'],
      });
    }
  }, []);

  useEffect(() => {
    if (memberId) {
      loadHeaderData(memberId);
    }
  }, [loadHeaderData]);

  if (memberId) {
    return <AuthenticatedHeader />;
  } else {
    return <AnonymousHeaderWrapper />;
  }
};

export const HeaderContainerWithProviders: React.FunctionComponent = () => {
  return (
    <ComponentWrapper>
      <HeaderContainer />
    </ComponentWrapper>
  );
};
